import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import Carousel, {ConfigType, ECarouselDirection} from 'brandComponents/Carousel';
import InTheMoodForTile from 'brandComponents/InTheMoodFor/InTheMoodForTile';

import messages from './messages';

import styles from './InTheMoodForBanner.module.scss';

const InTheMoodForBanner = () => {
	const intl = useIntl();
	const {ITMFData, isITMF, cgid, showITMFBanner} = useCategoryContext(true) || {};

	const carouselConfig: ConfigType = useMemo(() => ({
		direction: ECarouselDirection.HORIZONTAL,
		freeMode: true,
		slidesPerView: 'auto',
		spaceBetween: 32,
		slidesOffsetAfter: 16,
		slidesOffsetBefore: 16,
		breakpoints: {
			992: {
				slidesOffsetAfter: 20,
				slidesOffsetBefore: 20
			}
		}
	}), []);

	const slides = useMemo(() => {
		return ITMFData?.subItems.map((subItem, i) => ({
			key: `${i}-${subItem.category}`,
			elem: (
				<InTheMoodForTile
					categoryId={subItem.category}
					image={subItem.image}
					hoverImg={subItem.hoverImg}
					title={subItem.title}
					active={subItem.category === cgid}
					hoverImgsLimit={3}
				/>
			)
		}));
	}, [cgid]);

	if (!isITMF || !ITMFData || !showITMFBanner) {
		return;
	}

	return (
		<div className={cn(styles['itmf-banner'], 'itmf-banner')}>
			<div className={styles['itmf-banner__title']}>
				{intl.formatMessage(messages.title)}
			</div>
			<Carousel
				config={carouselConfig}
				classNames={{
					swiper: styles['itmf-banner__carousel']
				}}
			>
				{slides}
			</Carousel>
		</div>
	);
};

export default InTheMoodForBanner;
